/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import TextField from '@mui/material/TextField';
import * as R from 'ramda';

const renderInput = R.curry((label, params) => (
  <TextField
    {...params}
    label={label}
    slotProps={{
      htmlInput: { ...params.inputProps },

      input: {
        ...params.InputProps,
        endAdornment: params.InputProps.endAdornment,
      },
    }}
  />
));

export default renderInput;
